export default __webpack_public_path__ + "static/media/logo-trim.251b0568.svg";